var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"bc71233879966a2715c76dce6f616a223fee1565"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // integrations: [new Sentry.Replay()],
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  //Excluding Network error to be sent on sentry
  beforeSend(event, hint) {
    const errorMessages = [
      "Network request failed",
      "Failed to fetch",
      "NetworkError",
      "timeout exceeded",
      "withrealtime/messaging",
      "Request failed with status code 401",
      "Request failed with status code 403",
      "opts is not defined",
      "Unexpected token '='",
      "Request failed with status code 404",
      "Request aborted",
      "Network Error",
      "Internal Server Error",
      "Content Security Policy",
      "ContentSecurityPolicyError",
      "ContentSecurityPolicy",
    ];
    const errorMessage = event.exception?.values?.[0]?.value;
    const isCSPViolation = event.request?.url?.includes("/csp-report");

    if (
      (errorMessage && errorMessages.includes(errorMessage)) ||
      isCSPViolation ||
      event.exception?.values?.[0]?.type === "ContentSecurityPolicy" ||
      event.exception?.values?.[0]?.value === "503 Service Unavailable"
    ) {
      console.log("Client beforeSend Function: Event Ignored:", event);
      return null;
    }

    if (event.exception && event.exception.values) {
      const errorType = event.exception.values?.[0]?.type;
      const errorMessage: any = event.exception.values?.[0]?.value; // Get the full error message

      if (errorType === "ReferenceError" && errorMessage?.includes("gmo")) {
        return null; // Ignore only "Can't find variable: gmo"
      }

      if (
        errorType === "UnhandledRejection" &&
        errorMessage ===
          "Non-Error promise rejection captured with value: undefined"
      ) {
        return null;
      }
      if (errorMessage.includes("_leaflet_pos")) {
        return null; // Ignore this error
      }
    }

    console.log("Client beforeSend Function: Event Captured:", event);
    return event;
  },

  beforeBreadcrumb(breadcrumb, hint) {
    if (
      (breadcrumb.category === "csp" && breadcrumb.type === "error") ||
      breadcrumb.category === "xhr"
    ) {
      return null; // Ignore CSP errors by returning null
    }

    // console.log("Client Captured Breadcrumb:", breadcrumb);
    return breadcrumb; // Continue processing other types of breadcrumbs
  },
});
Sentry.setTag("env", process.env.NEXT_PUBLIC_SENTRY_ENV);
